import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export function usePortfolioHealth(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'portfolio', 'health'],
    queryFn: () => apiClient.portfolio.getHealth(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useTurfAnalysis(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'portfolio', 'turf'],
    queryFn: () => apiClient.portfolio.getTurf(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useCannibalization(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'portfolio', 'cannibalization'],
    queryFn: () => apiClient.portfolio.getCannibalization(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useRationalization(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'portfolio', 'rationalization'],
    queryFn: () => apiClient.portfolio.getRationalization(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useDueToDecomposition(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'portfolio', 'due-to'],
    queryFn: () => apiClient.portfolio.getDueTo(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}
